import { Card } from "../../../components/Card";
import { Skeleton } from "../../../components/Skeleton";
import { AchievementsWidgetBadgesSkeleton } from "./AchievementsWidgetSkeleton";

function GoalCardSkeleton() {
    return (
        <div className="p-3 rounded-[5px] bg-gray-301 flex items-center justify-between">
            <div className="flex flex-col gap-4 flex-[4]">
                <Skeleton className="h-4 w-full max-w-[280px]" />
                <div className="flex items-center gap-2">
                    <Skeleton className="h-[9px] flex-1 rounded-full" />
                    <Skeleton className="h-4 w-8" />
                </div>
            </div>
            <Skeleton className="w-4 h-4 rounded-full shrink-0" />
        </div>
    );
}

function BadgeCurrentStatusSkeleton() {
    return (
        <div className="flex justify-between items-center p-[18px] bg-white shadow-[0_2.957px_2.957px_0_rgba(203,90,90,0.05)] rounded-[10px]">
            <div className="flex flex-col gap-1 flex-1">
                <div className="flex justify-between gap-2 items-center">
                    <Skeleton className="h-6 w-56" />
                    <Skeleton className="h-5 w-40 hidden sm:block" />
                </div>
                <Skeleton className="h-5 w-72 max-w-full" />
                <div className="flex flex-col gap-2 mt-3">
                    <Skeleton className="h-4 w-40" />
                    <div className="flex items-center gap-4">
                        <Skeleton className="h-[9px] flex-1 rounded-full" />
                        <Skeleton className="h-4 w-28 shrink-0" />
                    </div>
                </div>
            </div>
        </div>
    );
}

function BadgeCenterActivitySkeleton() {
    return (
        <Card className="!p-[18px]">
            <div className="flex flex-col gap-2">
                <Skeleton className="h-5 w-36" />
                <div className="items-center gap-2 flex w-full">
                    {[1, 2, 3, 4].map((item) => (
                        <div key={item} className="px-3 py-2.5 bg-gray-301 rounded-md flex flex-col gap-2 w-full">
                            <Skeleton className="h-3 w-16" />
                            <Skeleton className="h-5 w-10" />
                        </div>
                    ))}
                </div>
                {[1, 2, 3].map((item) => (
                    <div key={item} className="bg-gray-301 p-3 rounded-[6px] flex items-center justify-between">
                        <Skeleton className="h-4 w-28" />
                        <Skeleton className="h-4 w-12" />
                    </div>
                ))}
            </div>
        </Card>
    );
}

function AchievementsWidgetSkeleton() {
    return (
        <Card className="!p-[18px]">
            <div className="flex flex-col mb-2">
                <div className="flex flex-col gap-1 mb-2">
                    <div className="flex items-center justify-between">
                        <Skeleton className="h-5 w-28" />
                        <Skeleton className="h-5 w-20" />
                    </div>
                    <Skeleton className="h-4 w-52" />
                </div>
                <AchievementsWidgetBadgesSkeleton />
            </div>
        </Card>
    );
}

function BadgeCenterWeeklyGoalsSkeleton() {
    return (
        <Card className="!p-[18px]">
            <div className="flex flex-col mb-2">
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-4 w-56 mt-1" />
            </div>
            <GoalCardSkeleton />
        </Card>
    );
}

function BadgeCenterFieldPro1Skeleton() {
    return (
        <Card className="!p-[18px] h-[350px]">
            <div className="flex flex-col mb-2">
                <Skeleton className="h-5 w-64" />
            </div>
            <div className="flex flex-col gap-2">
                {[1, 2, 3].map((item) => (
                    <GoalCardSkeleton key={item} />
                ))}
            </div>
        </Card>
    );
}

export function BadgeCenterSkeleton() {
    return (
        <div className="flex flex-col gap-4 relative">
            <BadgeCurrentStatusSkeleton />
            <div className="flex flex-col xl:flex-row gap-4 items-stretch">
                <div className="flex flex-[5] flex-col gap-4">
                    <BadgeCenterActivitySkeleton />
                    <AchievementsWidgetSkeleton />
                </div>
                <div className="flex flex-[4] flex-col gap-4">
                    <BadgeCenterWeeklyGoalsSkeleton />
                    <BadgeCenterFieldPro1Skeleton />
                </div>
            </div>
        </div>
    );
}
